import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { WPRangedInput } from "../../packages/WPInput/WPRangedInput";
import { Default_CIP_INFORMATION } from "./defaultCIPInformationFields.config";

const CIPSection = ({
  defaultCIPKeys,
  handleInputChange,
  disabled,
  existingCIPState,
}) => {
  const { t } = useTranslation();
  const { temperature, mass } = useSelector((state) => state);
  const defaultCIPState = useSelector((state) => ({
    acid_used_per_cip: state.acid_used_per_cip,
    alkali_used_per_cip: state.alkali_used_per_cip,
    additional_chemical_per_cip: state.additional_chemical_per_cip,
    acid_cip_ph: state.acid_cip_ph,
    alkali_cip_ph: state.alkali_cip_ph,
    cip_solution_ph: state.cip_solution_ph,
    acid_cip_temp: state.acid_cip_temp,
    alkali_cip_temp: state.alkali_cip_temp,
    cip_solution_temp: state.cip_solution_temp,
    acid_cip_duration: state.acid_cip_duration,
    alkali_cip_duration: state.alkali_cip_duration,
    cip_solution_duration: state.cip_solution_duration,
  }));
  const defaultFields = Default_CIP_INFORMATION(temperature, mass);
  return (
    <div className="sub-grid-container ">
      {defaultCIPKeys?.map((key) => (
        <div key={key} className="default-cip-section">
          <div className="section-title">{key} CIP</div>
          <div className="sub-grid-item">
            {Object.values(defaultFields[key] || {}).map((field, index) => (
              <WPRangedInput
                key={index}
                value={
                  existingCIPState && existingCIPState[field.key] !== undefined
                    ? existingCIPState[field.key]
                    : defaultCIPState[field.key]
                }
                name={field.key}
                label={t(`defaultInformationStrings.${field.key}`)}
                suffix={field.unit}
                onChange={
                  disabled
                    ? undefined
                    : (e) =>
                        handleInputChange(
                          field.key,
                          e.target.value,
                          field.ranges?.hard?.min,
                          field.ranges?.hard?.max,
                        )
                }
                ranges={field.ranges}
                disabled={disabled}
                required
                requiredMsg={t("ValueStrings.requiredField")}
              />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default CIPSection;
